<template>
  <b-alert show variant="success" dismissible>
      {{ message }}
  </b-alert>
</template>

<script>
export default {
  name: 'NotificationContainer',
  props: {
    message: String
  }
}
</script>
